const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

/** camelCase / PascalCase → snake_case for Pulse JSON keys. */
export const toSnakeCaseKey = (key: string): string =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .toLowerCase();

/** Recursively normalize object keys to snake_case (arrays of objects included). */
export const normalizePulseKeys = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(normalizePulseKeys);
  }
  if (!isPlainObject(value)) {
    return value;
  }

  const normalized: Record<string, unknown> = {};
  for (const [key, nested] of Object.entries(value)) {
    normalized[toSnakeCaseKey(key)] = normalizePulseKeys(nested);
  }
  return normalized;
};
